import React from 'react';
import { LinkProps, Link } from 'react-router-dom';

const FIRST_DIRECTORY_REGEX = /\/([a-zA-Z]*)\/(.*)/;

export const InAppLink: React.FC<LinkProps> = ({ to, ...props }) => {
  if (typeof to !== 'function') {
    const pathname = typeof to === 'string' ? to : to.pathname;
    const state = typeof to === 'string' ? {} : to.state;

    if (typeof pathname === 'string') {
      const match = pathname?.match(FIRST_DIRECTORY_REGEX);
      const firstPath = match ? match[1] : pathname;
      const restOfThePath = match ? match[2] : '';
      const nextRouterState = restOfThePath
        ? {
            url: `/${firstPath}/[...${firstPath}]?${firstPath}=${restOfThePath}`,
            as: `/${firstPath}/${restOfThePath}`,
            options: {},
          }
        : { url: firstPath };

      return (
        <Link
          {...props}
          to={{
            pathname,
            state: {
              ...state,
              ...nextRouterState,
            },
          }}
        />
      );
    }
  }

  return <Link to={to} {...props} />;
};
